import { Box, Button, Stack, Typography } from '@mui/material';
import { cloneDeep, get, set } from 'lodash';
import React, { FC, useEffect, useState } from 'react';
import CreateForm from '../../../../../components/ui-component/form-component/create-form/CreateForm';
import LoadingIconOnly from '../../../../../components/ui-component/loading/LoadingIconOnly';
import MuiSnackbar from '../../../../../components/ui-component/mui-snackbar/MuiSnackbar';
import { useAuthentication } from '../../../../../context/AuthContext';
import GetRecord from '../../../../../lib/api/GetRecord';
import POP_LEVEL from '../../../../../lib/api/Populations.json';
import { PostRecord } from '../../../../../lib/api/PostRecord';
import PutRecord from '../../../../../lib/api/PutRecord';
import { APIS } from '../../../../../lib/constants/apis';
import { NOT_FOUND_ERROR_MESSAGE } from '../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../lib/types/types';
import { removeDataKeys, removeNullDeep } from '../../../../../utils/helper';

// import Schemas
import Schema from '../../../../../lib/paths/unternehmen_FULL_Paths.json';
let P = Schema.attributes;

const formStruc: FormStrucItem[] = [
	{
		fields: [
			// P.Geschaeftsbezogene_Daten_Bewilligung,
			{ ...P.Geschaeftsbezogene_Daten_0074345863_ikschule_Im_Land_Brandenburg, label: 'Anerkannte Musik- und Kunstschule im Land Brandenburg' },		
			P.Geschaeftsbezogene_Daten_0009672916_Ueber_Die_Gemeinnuetzigkeit,
			P.Geschaeftsbezogene_Daten_Satzung,
			P.Geschaeftsbezogene_Daten_0201658163_register_Handelsregister_Etc,
		],
		userProps: { direction: 'column', columnToDivide: 2, rowGap: 1 },
	},
];

const OrganisationDocuments: FC<{}> = () => {
	const { authenticatedData } = useAuthentication();
	const [loading, setLoading] = useState<boolean>(true);
	const [updateSuccess, setUpdateSuccess] = useState<boolean | null>(null);
	const [wsError, setWsError] = useState<boolean>(false);
	const [organisationData, setOrganisationData] = useState<Record<string, any>>({});
	const [formErrors] = useState<Record<string, any>>({});

	const handleInputChange = (path: string, value: any) => {
		setUpdateSuccess(null);
		let organisationDataCopy = cloneDeep(organisationData);
		set(organisationDataCopy, path, value);
		setOrganisationData(organisationDataCopy);
	};
	const handleUpdateOrganisationData = async () => {
		let res = await PutRecord(
			APIS.Organisation,
			get(authenticatedData, 'organisationId'),
			{
				data: get(organisationData, 'attributes'),
			},
			POP_LEVEL.unternehmen.FULL
		);
		if (get(res, 'data.id')) {
			let pushNotificationData = { data: { entities: [{ api: APIS.Organisation, id: get(res, 'data.id') }] } };
			await PostRecord(APIS.PushNotificaiton, pushNotificationData);
			setUpdateSuccess(true);
		}
	};

	useEffect(() => {
		const fetchOrganisation = async () => {
			setLoading(true);
			try {
				let res = await GetRecord(APIS.Organisation, get(authenticatedData, 'organisationId'), POP_LEVEL.unternehmen.DOKUMENTE);
				setOrganisationData(removeNullDeep(removeDataKeys(get(res, 'data', {}))));
			} catch (err) {
				console.error('ERROR Fetching Organisation ', err);
				setWsError(true);
			} finally {
				setLoading(false);
			}
		};
		fetchOrganisation();
	}, [authenticatedData]);

	if (loading) return <LoadingIconOnly />;
	return (
		<>
			<MuiSnackbar showSnackbar={wsError} closeSnackbar={() => setWsError(false)} alertMessage={NOT_FOUND_ERROR_MESSAGE} error={wsError} />
			<MuiSnackbar showSnackbar={updateSuccess} closeSnackbar={() => setUpdateSuccess(null)} alertMessage='Daten wurde aktualisiert' />
			<Typography variant='h3' component='h2' sx={{ mb: '1rem' }}>
				Dokumente meiner Organisation
			</Typography>
			<Stack direction={{ xs: 'column', md: 'row' }} alignItems={{ xs: 'center', md: 'flex-start' }} sx={{ mb: '1rem' }}>
					<Typography>Bescheid gültig bis: {get(organisationData, 'attributes.Geschaeftsbezogene_Daten_Gueltig_Bis', '') || ''}</Typography>
			</Stack>
			<CreateForm
				formStruc={formStruc}
				formValues={organisationData}
				formErrors={formErrors}
				updateFormValuesFunc={handleInputChange}
				api={APIS.Organisation}
			/>

			<Box sx={{ textAlign: 'right', mt: '2rem' }}>
				<Button onClick={handleUpdateOrganisationData}>Aktualisieren</Button>
			</Box>
		</>
	);
};
export default OrganisationDocuments;
